import * as types from '../actionTypes/lookupCode'

export function getGenders(genders) {
  return {
    type: types.GET_GENDERS,
    genders
  }
}

export function getQualifications(qualifications) {
  return {
    type: types.GET_QUALIFICATIONS,
    qualifications
  }
}

export function getSkills(skills) {
  return {
    type: types.GET_SKILLS,
    skills
  }
}

export function getRegions(regions) {
  return {
    type: types.GET_REGIONS,
    regions
  }
}


// WEBPACK FOOTER //
// ./src/actions/lookupCode.js